import { useEffect } from 'react';
import { ESTIMULO_BRAND, POLIGONO_BRAND, getProductBrand } from 'constants/brand-constants';

export const useBrandTheme = (bizId?: string | null) => {
    useEffect(() => {
        const brand = getProductBrand(bizId);
        document.documentElement.style.setProperty('--primary-color', brand.primaryColor);
        document.documentElement.style.setProperty('--secondary-color', brand.secondaryColor);
        document.documentElement.style.setProperty('--tertiary-color', brand.tertiaryColor);

        const favicon = document.querySelector<HTMLLinkElement>('link[rel="shortcut icon"]');
        if (favicon) {
            if (brand.branchName === POLIGONO_BRAND.branchName) {
                favicon.href = '/favicon-poligono.webp';
            } else if (brand.branchName === ESTIMULO_BRAND.branchName) {
                favicon.href = '/estimulo_favicon.png';
            } else {
                favicon.href = '/favicon.ico';
            }
        }
    }, [bizId]);
};
